"use client";

import { ChevronsDown, Hand } from "lucide-react";

type Props = {
	visible: boolean;
};

/** Hand gesture overlay synced with live preview scroll nudge (matches mobile app). */
export function LivePreviewScrollHintHandOverlay({ visible }: Props) {
	if (!visible) return null;

	return (
		<div
			className="pointer-events-none absolute inset-0 z-[20] flex items-center justify-center"
			aria-hidden
		>
			<div className="live-preview-scroll-hint-hand -translate-y-[8%] flex flex-col items-center motion-reduce:translate-y-0 motion-reduce:animate-none">
				<div className="flex size-[4.5rem] items-center justify-center rounded-full border border-white/35 bg-black/35 shadow-lg backdrop-blur-md sm:size-20">
					<Hand className="size-9 text-white sm:size-10" strokeWidth={2} aria-hidden />
				</div>
				<ChevronsDown
					className="mt-2 size-6 text-white/90 drop-shadow-[0_1px_3px_rgba(0,0,0,0.45)] sm:size-7"
					strokeWidth={2}
					aria-hidden
				/>
			</div>
		</div>
	);
}
